<template>
  <v-card outlined class="pa-4 rounded-lg" :loading="loading">
    <h6>Compras</h6>
    <v-expansion-panels focusable>
      <v-expansion-panel
        v-for="party in paymentsGroupedByParty"
        :key="party.id"
      >
        <v-expansion-panel-header class="pl-1 py-1 gap-3 d-flex align-center">
          <div class="flex-grow-0">
            <v-img
              :src="party.cover"
              :alt="party.name"
              :width="(45 * 16) / 9"
              height="45"
              class="rounded"
              :aspect-ratio="16 / 9"
            />
          </div>
          <div>
            <p class="mb-0 font-weight-bold">{{ party.name }}</p>
          </div>
          <v-spacer />
          <div class="d-flex flex-column justify-end flex-grow-0 align-end">
            <b class="font-weight-bold">
              {{ party.totalValue | currency }}
            </b>
            <div>
              <span class="text-12">
                {{ party.totalTickets }}
                {{ party.totalTickets === 1 ? "ingresso" : "ingressos" }} •
                {{ party.Payments.length }}
                {{ party.Payments.length === 1 ? "pagamento" : "pagamentos" }}
              </span>
            </div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table :headers="headers" :items="party.Payments">
            <template v-slot:item.id="{ item }">
              <span class="text-overline lh-1">
                {{ item.id | shortId }}
              </span>
            </template>
            <template v-slot:item.amount="{ item }">
              {{ item.amount | currency }}
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip small label :color="ticketStatus[item.status].color">
                {{ ticketStatus[item.status].text }}
              </v-chip>
            </template>
            <template v-slot:item.createdAt="{ item }">
              {{ item.createdAt | date("DD/MM/YYYY HH:mm") }}
            </template>
            <template v-slot:item.paymentType="{ item }">
              <span class="d-block text-13">{{
                paymentType[item.paymentType].text
              }}</span>
              <small>{{ paymentMethod[item.paymentMethod]?.text || item.paymentMethod }}</small>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import PAYMENT from "@/utils/payment";

export default {
  name: "UserPayments",
  data() {
    return {
      ticketStatus: PAYMENT.ticketStatus,
      paymentMethod: PAYMENT.paymentMethod,
      paymentType: PAYMENT.paymentType,
      headers: [
        { text: "#", value: "id" },
        { text: "Data", value: "createdAt" },
        { text: "Valor", value: "amount" },
        { text: "Status", value: "status" },
        { text: "Ingressos", value: "Ticket.length", align: "center" },
        { text: "Pagamento", value: "paymentType", align: "center" },
      ],
    };
  },
  computed: {
    paymentsGroupedByParty() {
      if (!this.user?.Payments) return [];
      return Object.values(
        this.user.Payments.reduce((acc, payment) => {
          const ticket = payment.Ticket?.[0];
          const party = ticket?.TicketBlock?.TicketGroup?.Party;
          if (!party) return acc;
          if (!acc[party.id]) {
            acc[party.id] = {
              ...party,
              totalTickets: 0,
              totalValue: 0,
              Payments: [],
            };
          }
          acc[party.id].Payments.push(payment);
          if (payment.status === "succeeded") {
            acc[party.id].totalTickets += payment.Ticket.length;
            acc[party.id].totalValue += payment.amount;
          }
          return acc;
        }, {})
      );
    },
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
